
import { defineComponent, PropType } from 'vue'

// @components
import ButtonDropdown from '@/common/components/UI/ButtonDropdown/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    name: 'delivery-table-row-actions',
    components: { ButtonDropdown, TheButton },
    emits: ['payment', 'wait-list'],
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
    },
    setup(props, { emit }) {
        const emitPayment = (type: number) => emit('payment', type)
        const emitWaitList = () => emit('wait-list', { ...props.row })

        return {
            emitPayment,
            emitWaitList,
        }
    },
})
